import React, { useState } from "react";
import AboutMe from "../components/AboutMe/AboutMe";
import BlogPosts from "../components/BlogPosts/BlogPosts";
import Contact from "../components/Contact/Contact";
import DetailtsModal from "../components/DetailtsModal/DetailtsModal";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import Hero from "../components/Hero/Hero";
import MyPortfolio from "../components/MyPortfolio/MyPortfolio";
import MyServices from "../components/MyServices/MyServices";
import MySkills from "../MySkills/MySkills";
import MessengerCustomerChat from "react-messenger-customer-chat";
import Achievement from "../components/Achievement/Achievement";
import ProfessionalSkill from "../components/ProfessionalSkill/ProfessionalSkill";
import MySkils from "../components/MySkilsF/MySkils";
import AnimatedBar from "../components/AnimatedBar/AnimatedBar";

const Home = () => {
  const [detailsP, setDetailsP] = useState({});
  const handleDetailsProject = (details) => {
    setDetailsP(details);
  };
  return (
    <>
      <DetailtsModal detailsP={detailsP} />
      <div className="">
        <Header />
        <Hero />
        <AboutMe />
        {/* <AnimatedBar /> */}
        <MySkills />
        <Achievement />
        {/* <ProfessionalSkill /> */}
        {/* <MySkils /> */}
        <MyPortfolio handleDetailsProject={handleDetailsProject} />
        <MyServices />
        {/* <MyResume /> */}
        <BlogPosts />
        <Contact />
        <Footer />
        <div>
          <MessengerCustomerChat
            pageId="102742788066635"
            appId="480700503450921"
          />
        </div>
      </div>
    </>
  );
};

export default Home;
